import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppGuard } from './app.guard';

const routes: Routes = [
  { path: '', redirectTo: 'loading', pathMatch: 'full' },
  { 
    path: ':cfgDeviceId/:cfgFileName',
    loadChildren: () => import('./pages/loading/loading.module').then(m => m.LoadingPageModule)
  },
  { 
    path: 'loading',
    loadChildren: () => import('./pages/loading/loading.module').then(m => m.LoadingPageModule)
  },
  { path: ':cfgDeviceId/:cfgFileName/auth',
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule),
    canActivate: [AppGuard]
  },
  { path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthPageModule),
    canActivate: [AppGuard]
  },
  {
    path: ':cfgDeviceId/:cfgFileName/tables',
    loadChildren: () => import('./pages/modes/tables/tables.module').then(m => m.TablesPageModule),
    canActivate: [AppGuard]
  },
  {
    path: 'tables',
    loadChildren: () => import('./pages/modes/tables/tables.module').then(m => m.TablesPageModule),
    canActivate: [AppGuard]
  },
  {
    path: ':cfgDeviceId/:cfgFileName/sco',
    loadChildren: () => import('./pages/modes/sco/sco.module').then(m => m.SCOPageModule),
    canActivate: [AppGuard]
  },
  {
    path: 'sco',
    loadChildren: () => import('./pages/modes/sco/sco.module').then(m => m.SCOPageModule),
    canActivate: [AppGuard]
  },
  {
    path: ':cfgDeviceId/:cfgFileName/pos-lite',
    loadChildren: () => import('./pages/modes/pos-lite/pos-lite.module').then(m => m.POSLitePageModule),
    canActivate: [AppGuard]
  },
  {
    path: 'pos-lite',
    loadChildren: () => import('./pages/modes/pos-lite/pos-lite.module').then(m => m.POSLitePageModule),
    canActivate: [AppGuard]
  },
  { path: ':cfgDeviceId/:cfgFileName/pos-full',
    loadChildren: () => import('./pages/modes/pos-full/pos-full.module').then(m => m.POSFullPageModule),
    canActivate: [AppGuard]
  },
  { path: 'pos-full',
    loadChildren: () => import('./pages/modes/pos-full/pos-full.module').then(m => m.POSFullPageModule),
    canActivate: [AppGuard]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' }),
  ],
  exports: [
    RouterModule
  ],
})
export class AppRoutingModule { }
